import { getFileName } from 'helpers/image.helper';
import { compact, map, reduce } from 'lodash';
import { PickedPhotosModel } from 'models/common.model';
import {
  LayoutPhotoModel,
  PictureOfPhotoModel,
} from 'models/photo/layout.model';

/**
 * lấy pickedPhoto từ mini layout
 */
function getPickedPhotoSource(
  pickedPhotos: Array<PickedPhotosModel | PictureOfPhotoModel | null>,
  itemInLayoutPictures: PictureOfPhotoModel,
  indexItemInLayoutPictures: number,
): PickedPhotosModel | PictureOfPhotoModel | null {
  const isMiniPicture = itemInLayoutPictures?.isMiniPicture;

  if (!isMiniPicture) return pickedPhotos?.[indexItemInLayoutPictures] || null;

  const pictureSourceIndex = Math.max(
    itemInLayoutPictures?.pictureTarget - 1,
    0,
  );

  return pickedPhotos?.[pictureSourceIndex] || null;
}

/**
 * Tạo thêm ảnh mini từ pickedPhotos và layout ...
 */
function addMiniPictureForPicked(
  pickedPhotos: Array<PickedPhotosModel | null>,
  currentLayout: LayoutPhotoModel | null,
): Array<PickedPhotosModel | null> {
  return reduce(
    currentLayout?.pictures,
    (
      stacks: Array<PickedPhotosModel | null>,
      item: PictureOfPhotoModel,
      ind: number,
    ) => {
      const isMiniPicture = item?.isMiniPicture;

      if (!isMiniPicture) return [...stacks, pickedPhotos?.[ind] || null];

      return [
        ...stacks,
        getPickedPhotoSource(
          pickedPhotos,
          item,
          ind,
        ) as PickedPhotosModel | null,
      ];
    },
    [],
  );
}

/**
 * Tạo thêm ảnh mini từ pickedPhotos và layout ...
 */
function processPickedPhotos(
  pickedPhotos: Array<PickedPhotosModel | null>,
  currentLayout: LayoutPhotoModel | null,
  {
    backgroundId,
    filterId,
    filterType,
  }: { backgroundId: number; filterId: number; filterType: number },
): Array<PickedPhotosModel | null> {
  return map(
    addMiniPictureForPicked(compact(pickedPhotos), currentLayout),
    (item) => ({
      fileName: getFileName(filterId, filterType, item?.fileName || ''),
      rotate: item?.rotate || 0,
      flip: item?.flip === -1 ? 0 : null,
      isDigitalBackground: !!backgroundId,
      digitalBackgroundId: backgroundId,
    }),
  );
}

export { getPickedPhotoSource, addMiniPictureForPicked, processPickedPhotos };
